import React, { useEffect, useRef, useState } from 'react';

import { useHeaderContext } from '../../HeaderContextProvider';
import { RewardIcon } from '../../assets/RewardIcon';
import MenuItem from '../../MenuItem';
import {
  StyledContainer,
  StyledEmptySpace,
  StyledMenuItems,
  StyledMenuItemsAndOverlays,
  StyledMenuItemsContainer,
  StyledOpacityOverlay,
  StyledRewardContainer,
  StyledRewardIconValue,
  StyledRewardValue,
} from './styles';

interface TProps {
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileMenuItemsAndRewards = ({ setOpenMenu }: TProps) => {
  const scrollableRef = useRef<null | HTMLInputElement>(null);
  const [isScrollArrowVisible, setIsScrollArrowVisible] = useState(false);
  const [showBottomOverlay, setShowBottomOverlay] = useState(true);
  const [showTopOverlay, setShowTopOverlay] = useState(false);

  const {
    menuItems,
    isMenuItemsLoading,
    userFirstname,
    isStoreEnabled,
    totalRewardsValue,
    colorsPaletteFromBO,
    navigate,
  } = useHeaderContext();

  const checkIsScrollable = () => {
    if (
      scrollableRef &&
      scrollableRef.current &&
      scrollableRef.current.scrollHeight > scrollableRef.current.clientHeight
    ) {
      setIsScrollArrowVisible(true);
    } else {
      setIsScrollArrowVisible(false);
    }
  };

  const handleScroll = () => {
    if (scrollableRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollableRef.current;
      setShowTopOverlay(scrollTop > 0);
      setShowBottomOverlay(scrollTop + clientHeight < scrollHeight);
    }
  };

  useEffect(() => {
    const observer = new MutationObserver(checkIsScrollable);
    const scrollableElement = scrollableRef.current;

    if (scrollableElement) {
      observer.observe(scrollableElement, {
        childList: true,
        subtree: true,
      });
      checkIsScrollable();
      scrollableElement.addEventListener('scroll', handleScroll, {
        passive: true,
      });
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener('scroll', handleScroll);
      }
      observer.disconnect();
    };
  }, []);

  if (isMenuItemsLoading) {
    return <StyledEmptySpace />;
  }

  return (
    <StyledContainer>
      <StyledRewardContainer>
        <div>{userFirstname}</div>
        {isStoreEnabled && (
          <StyledRewardIconValue>
            <RewardIcon color="#f2b308" size="32" />
            <StyledRewardValue colorsPaletteFromBO={colorsPaletteFromBO}>
              {totalRewardsValue}
            </StyledRewardValue>
          </StyledRewardIconValue>
        )}
      </StyledRewardContainer>

      <StyledMenuItemsAndOverlays>
        {isScrollArrowVisible && showTopOverlay && (
          <StyledOpacityOverlay position="top" />
        )}
        {isScrollArrowVisible && showBottomOverlay && (
          <StyledOpacityOverlay position="bottom" />
        )}
        <StyledMenuItemsContainer ref={scrollableRef}>
          {/* keep children 'div' to detect horizontal scrolling feature */}
          <StyledMenuItems>
            {menuItems.map((menuItem) => (
              <MenuItem
                menuItem={menuItem}
                navigate={navigate}
                setOpenMenu={setOpenMenu}
                colorsPaletteFromBO={colorsPaletteFromBO}
              />
            ))}
          </StyledMenuItems>
        </StyledMenuItemsContainer>
      </StyledMenuItemsAndOverlays>
    </StyledContainer>
  );
};

export default MobileMenuItemsAndRewards;
